import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import { useSwStore } from '@/stores/use-sw-store';
import { SW_UPDATE_CHECK_INTERVAL } from '@/lib/sw-constants';
import './styles/globals.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register service worker for offline support + app update lifecycle
const updateSW = registerSW({
  onNeedRefresh() {
    useSwStore.getState().setNeedRefresh(true);
  },
  onOfflineReady() {
    useSwStore.getState().setOfflineReady(true);
    console.info('[SW] App ready to work offline');
  },
  onRegisteredSW(_url, registration) {
    if (registration) {
      useSwStore.getState().setRegistration(registration);
      // Check for updates periodically
      setInterval(() => { registration.update(); }, SW_UPDATE_CHECK_INTERVAL);
    }
  },
});

// Store the updateSW function so the store's updateApp() can call it
useSwStore.getState()._setUpdateFn(updateSW);
